import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW', {
  providedIn: 'root',
  factory: (): Window => window,
});

export const AUDIO_CONTEXT = new InjectionToken<AudioContext>('AUDIO_CONTEXT', {
  providedIn: 'root',
  factory: () => new AudioContext(),
});
